const translations = require('../translations');
const constants = require('../utils/constants');

let ORDER_SUMMARY_TABLE = null;
const PRICES = JSON.parse(document.getElementById('prices-data').dataset.prices);
let TOTAL_AMOUNT = 0.00;
let TOTAL_AMOUNT_NO_DISCOUNT = 0.00;
/** Montant dû après bon cadeau, avant remise code promo (base pour l’API promo et l’affichage). */
let AMOUNT_AFTER_GIFT_BEFORE_PROMO = 0.00;

const buildOrderSummaryTable = () => {
    const orderSummary = document.createElement('div');
    orderSummary.classList.add('tc-website-ordersummary');

    const orderSummaryTitle = document.createElement('h3');
    orderSummaryTitle.classList.add('order-summary-title');
    orderSummaryTitle.innerText = translations.ORDER_SUMMARY.title;

    const orderSummaryAlert = document.createElement('div');
    orderSummaryAlert.classList.add('order-summary-alert', 'visible');
    orderSummaryAlert.innerHTML = translations.ORDER_SUMMARY.alert;

    const orderSummaryTable = document.createElement('table');
    orderSummaryTable.classList.add('table', 'table-borderless', 'order-summary-table', 'hidden');
    orderSummaryTable.innerHTML = `
        <tbody>
        </tbody>
        <tfoot>
            <tr>
                <td colspan="2">Total:</td>
                <td class="total"></td>
            </tr>
        </tfoot>
    `;

    orderSummary.appendChild(orderSummaryTitle);
    orderSummary.appendChild(orderSummaryAlert);
    orderSummary.appendChild(orderSummaryTable);

    ORDER_SUMMARY_TABLE = orderSummaryTable;

    document.querySelectorAll('.clearfix.is-child-checkbox').forEach(childCheckbox => {
    childCheckbox.addEventListener('change', () => {
            updateOrderSummaryTable();
        });
    });

    return orderSummary;
}

const updateOrderSummaryTable = (regionID = null) => {
    if (regionID === null && document.getElementById('booking-form-flightData').value) {
        const flightData = JSON.parse(document.getElementById('booking-form-flightData').value);
        if (flightData['region'] !== undefined) {
            regionID = flightData['region'];
        }
    }

    if (regionID) {
        let totalAmount = 0.00;
        let areaData = [];

        PRICES['areas'].forEach(area => {
            if (area.id === regionID) {
                areaData = area;
            }
        });

        let passengers = {
            adult: {
                count: 0,
                price: 0.00
            },
            child: {
                count: 0,
                price: 0.00
            }
        };

        let nbPassengers = 0;

        document.getElementById('booking-form-passengersInformation')
            .querySelectorAll('.is-child-checkbox:not(.hidden)')
            .forEach(childCheckboxContainer => {
                nbPassengers++;
                let passengerType = '';
                const checkbox = childCheckboxContainer.querySelector('.form-check-input');
                checkbox.checked ? passengerType = 'child' : passengerType = 'adult';
                passengers[passengerType]['count']++;

                if(!areaData['prices'][passengerType]['preferentialRates']) {
                    totalAmount += areaData['prices'][passengerType]['price'];
                    passengers[passengerType]['price'] += areaData['prices'][passengerType]['price'];
                }
            });

        if (areaData['prices']['adult']['preferentialRates'] && passengers.adult.count !== 0) {
            const adultsAmount = getPreferentialAmount(areaData, 'adult', passengers.adult.count);
            totalAmount += adultsAmount;
            passengers.adult.price += adultsAmount;
        }

        if (areaData['prices']['child']['preferentialRates'] && passengers.child.count !== 0) {
            const childrenAmount = getPreferentialAmount(areaData, 'child', passengers.child.count);
            totalAmount += childrenAmount;
            passengers.child.price += childrenAmount;
        }

        if (!ORDER_SUMMARY_TABLE) {
            buildOrderSummaryTable();
        }

        const discountRow = ORDER_SUMMARY_TABLE.querySelector('.discount-row');
        let availableAmount = null;
        if (discountRow) {
            availableAmount = parseFloat(discountRow.dataset.availableAmount);
        } else if (document.getElementById('gift-voucher-code-length') && constants.existingReservation && constants.reservation.giftVoucherAmount) {
            availableAmount = parseFloat(constants.reservation.giftVoucherAmount);
        }

        removeAllEntries();

        if (passengers.adult.count > 0) {
            const adultEntry = createNewEntry(passengers.adult.count, 'adult', passengers.adult.price);
            ORDER_SUMMARY_TABLE.querySelector('tbody').appendChild(adultEntry);
        }

        if (passengers.child.count > 0) {
            const childEntry = createNewEntry(passengers.child.count, 'child', passengers.child.price);
            ORDER_SUMMARY_TABLE.querySelector('tbody').appendChild(childEntry);
        }

        ORDER_SUMMARY_TABLE.querySelector('.total').innerText = formatNumber(totalAmount);
        TOTAL_AMOUNT = TOTAL_AMOUNT_NO_DISCOUNT = totalAmount;

        if (availableAmount) {
            addGiftVoucherDiscount(availableAmount);
        }

        AMOUNT_AFTER_GIFT_BEFORE_PROMO = TOTAL_AMOUNT;
        document.dispatchEvent(new CustomEvent('tcwebsite:orderSummaryUpdated', { bubbles: true }));
    }
}

const addGiftVoucherDiscount = (amount) => {
    let discount = amount * -1;
    if (amount > TOTAL_AMOUNT_NO_DISCOUNT) {
        discount = TOTAL_AMOUNT_NO_DISCOUNT * -1;
        addGiftVoucherRemainingAmount(amount - TOTAL_AMOUNT_NO_DISCOUNT);
    } else {
        removeGiftVoucherRemainingAmount();
    }

    const discountEntry = document.createElement('tr');
    discountEntry.dataset.availableAmount = amount;
    discountEntry.classList = 'discount-row';
    discountEntry.innerHTML = `
        <td></td>
        <td>Bon de réduction</td>
        <td class="price">` + formatNumber(discount) + `</td>
    `;

    ORDER_SUMMARY_TABLE.querySelector('tbody').appendChild(discountEntry);
    TOTAL_AMOUNT += discount;
    ORDER_SUMMARY_TABLE.querySelector('.total').innerText = formatNumber(TOTAL_AMOUNT);
}

const addGiftVoucherRemainingAmount = (remainingAmount) => {
    removeGiftVoucherRemainingAmount();

    const remainingAmountElement = document.createElement('i');
    remainingAmountElement.classList.add('remaining-amount');
    remainingAmountElement.innerText = translations.DISCOUNT_VOUCHER.remainingAmount.replace('%s', formatNumber(remainingAmount));

    document.querySelector('.tc-website-ordersummary').appendChild(remainingAmountElement);
}

const removeGiftVoucherDiscount = () => {
    ORDER_SUMMARY_TABLE.querySelectorAll('.discount-row').forEach((discountRow) => {
        TOTAL_AMOUNT -= parseFloat(discountRow.querySelector('.price').innerText);
        ORDER_SUMMARY_TABLE.querySelector('.total').innerText = formatNumber(TOTAL_AMOUNT);
        discountRow.remove();
    });

    removeGiftVoucherRemainingAmount();
}

const removeGiftVoucherRemainingAmount = () => {
    document.querySelectorAll('.tc-website-ordersummary > .remaining-amount').forEach((item) => {
        item.remove();
    });
}

const removePromoDiscountRow = () => {
    if (!ORDER_SUMMARY_TABLE) {
        return;
    }
    ORDER_SUMMARY_TABLE.querySelectorAll('.promo-discount-row').forEach((row) => {
        row.remove();
    });
    TOTAL_AMOUNT = AMOUNT_AFTER_GIFT_BEFORE_PROMO;
    ORDER_SUMMARY_TABLE.querySelector('.total').innerText = formatNumber(TOTAL_AMOUNT);
}

/**
 * @param {number} discountPositive remise CHF (positive) renvoyée par l’API
 * @param {?number} totalAfterPromo total TTC calculé côté serveur (optionnel)
 */
const addPromoDiscountRow = (discountPositive, totalAfterPromo = null) => {
    if (!ORDER_SUMMARY_TABLE || discountPositive <= 0) {
        return;
    }
    removePromoDiscountRow();

    const discount = Math.min(AMOUNT_AFTER_GIFT_BEFORE_PROMO, discountPositive) * -1;
    const discountEntry = document.createElement('tr');
    discountEntry.classList.add('promo-discount-row');
    discountEntry.innerHTML = `
        <td></td>
        <td>` + translations.ORDER_SUMMARY.promoCodeDiscount + `</td>
        <td class="price">` + formatNumber(discount) + `</td>
    `;

    ORDER_SUMMARY_TABLE.querySelector('tbody').appendChild(discountEntry);
    const hasServerTotal = Number.isFinite(totalAfterPromo);
    TOTAL_AMOUNT = hasServerTotal ? totalAfterPromo : (AMOUNT_AFTER_GIFT_BEFORE_PROMO + discount);
    ORDER_SUMMARY_TABLE.querySelector('.total').innerText = formatNumber(TOTAL_AMOUNT);
}

const getAmountForPromoValidation = () => AMOUNT_AFTER_GIFT_BEFORE_PROMO

/**
 * Compteurs + prix unitaires enfants pour l’API promo FAPDE (aligné sur le résumé commande).
 * @returns {{ adultCount: number, childAmounts: number[] }}
 */
const getPromoPassengerPayload = () => {
    let regionID = null;
    if (document.getElementById('booking-form-flightData') && document.getElementById('booking-form-flightData').value) {
        try {
            const flightData = JSON.parse(document.getElementById('booking-form-flightData').value);
            if (flightData['region'] !== undefined) {
                regionID = flightData['region'];
            }
        } catch (e) {
            regionID = null;
        }
    }

    let adultCount = 0;
    let childCount = 0;
    const fieldset = document.getElementById('booking-form-passengersInformation');
    if (fieldset) {
        fieldset.querySelectorAll('.is-child-checkbox:not(.hidden)').forEach((childCheckboxContainer) => {
            const checkbox = childCheckboxContainer.querySelector('.form-check-input');
            if (checkbox && checkbox.checked) {
                childCount++;
            } else {
                adultCount++;
            }
        });
    }

    const childAmounts = [];
    if (!regionID || childCount === 0) {
        return { adultCount, childAmounts };
    }

    let areaData = null;
    PRICES['areas'].forEach((area) => {
        if (area.id === regionID) {
            areaData = area;
        }
    });
    if (!areaData) {
        return { adultCount, childAmounts };
    }

    // Prix unitaire enfant (identique pour chaque enfant, y compris tarifs préférentiels)
    let unitChild = areaData['prices']['child']['price'];
    if (areaData['prices']['child']['preferentialRates']) {
        const childrenTotal = getPreferentialAmount(areaData, 'child', childCount);
        unitChild = childCount > 0 ? childrenTotal / childCount : 0;
    }
    for (let i = 0; i < childCount; i++) {
        childAmounts.push(Math.round(unitChild * 100) / 100);
    }

    return { adultCount, childAmounts };
}

const getPreferentialAmount = (areaData, passengerType, nbPassengers) => {
    let amount = 0.00;
    const preferentialRates = areaData['prices'][passengerType]['preferentialRates'];
    const reduction = preferentialRates['reduction'];
    const from = preferentialRates['from'];
    const to = preferentialRates['to'];
    const price = areaData['prices'][passengerType]['price'];

    if (nbPassengers >= from && nbPassengers <= to) {
        amount = (price - (reduction * (nbPassengers - 1))) * nbPassengers;
    } else if (nbPassengers > to) {
        amount = (price - (reduction * (to - 1))) * nbPassengers;
    } else if (nbPassengers < from) {
        amount = price * nbPassengers;
    }

    return amount;
}

const createNewEntry = (nbPassengers, passengerType, amount) => {
    const flightText = passengerType === 'adult' ? translations.ORDER_SUMMARY.adultFlight : translations.ORDER_SUMMARY.childFlight;
    const newEntry = document.createElement('tr');

    newEntry.innerHTML = `
        <td>` + nbPassengers + `</td>
        <td>` + flightText + `</td>
        <td class="price">` + formatNumber(amount)+ `</td>
    `;

    return newEntry;
}

const removeAllEntries = () => {
    ORDER_SUMMARY_TABLE.querySelector('tbody').innerHTML = '';
}

const formatNumber = (number) => {
    return Intl.NumberFormat('fr-CH', {style: 'currency', currency: 'CHF'}).format(number);
}

module.exports = {
    buildOrderSummaryTable,
    updateOrderSummaryTable,
    addGiftVoucherDiscount,
    removeGiftVoucherDiscount,
    addPromoDiscountRow,
    removePromoDiscountRow,
    getAmountForPromoValidation,
    getPromoPassengerPayload,
    /** Total affiché courant (après gift/promo) — smoke verify. */
    getCurrentTotal: () => TOTAL_AMOUNT,
}
